import { useEffect, useState } from 'react';
import { loadConfig } from './config/loader';
import type { BrokerConfig } from './config/types';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import Header from './components/Header';
import TileGrid from './components/TileGrid';
import AllocationPanel from './components/AllocationPanel';

function AppShell({ config }: { config: BrokerConfig }) {
  const { authenticated, user } = useAuth();

  useEffect(() => {
    document.title = config.branding.title;
    document.documentElement.style.setProperty('--brand-color', config.branding.primaryColor);
  }, [config]);

  if (config.auth && !authenticated) {
    return <div className="loading">Authenticating…</div>;
  }

  const isPlatformAdmin = (user?.roles ?? []).includes('platform-admin');

  return (
    <div className="app">
      <Header branding={config.branding} user={user} instance={config.instance} />
      <main className="main">
        <TileGrid tiles={config.tiles} userRoles={user?.roles ?? []} />
        {isPlatformAdmin && <AllocationPanel />}
      </main>
    </div>
  );
}

export default function App() {
  const [config, setConfig] = useState<BrokerConfig | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadConfig()
      .then(setConfig)
      .catch((e: Error) => setError(e.message));
  }, []);

  if (error) return <div className="error">Configuration error: {error}</div>;
  if (!config) return <div className="loading">Loading…</div>;

  return (
    <AuthProvider config={config.auth}>
      <AppShell config={config} />
    </AuthProvider>
  );
}
